// @flow
import React, { Component } from 'react';

type Props = {
  file: string;
  line: number;
};

const GITHUB = 'https://github.com/postlight/lux/blob/stable';

class SourceLink extends Component<void, Props, void> {
  render() {
    const { props: { file, line } } = this;

    return (
      <small>
        <span className="fw6 mr1">
          Source:
        </span>
        <code className="text-light">
          <a
            href={`${GITHUB}/${file}#L${line}`}
            rel="noopener noreferrer"
            target="_blank"
          >
            {file}:{line}
          </a>
        </code>
      </small>
    );
  }
}

export default SourceLink;



// WEBPACK FOOTER //
// ./src/components/SourceLink/index.jsx